import { Components, Theme } from '@mui/material/styles';

import { getDataTestId } from '@/utils/browser';

import { elevationLevel } from '../constants';

export const autocompleteConfigs: Components<Theme>['MuiAutocomplete'] = {
  defaultProps: {
    size: 'small',
    fullWidth: true,
    slotProps: {
      paper: {
        ...getDataTestId(`autocomplete-menu`),
        elevation: elevationLevel.m,
        sx: theme => ({
          border: `1px solid ${theme.palette.grey[200]}`,
          padding: `${theme.spacing(2)} ${theme.spacing(1)}`,
        }),
      },
    },
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '&.MuiAutocomplete-hasPopupIcon, &.MuiAutocomplete-hasClearIcon, &.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon':
        {
          '.MuiFormControl-root': {
            '.MuiInputBase-root': {
              paddingRight: theme.spacing(2),
            },
          },
        },
    }),
  },
};
